module.exports = {
  id: 19,
  name: 'Bear Crawl',
  categories: ['strength', 'core', 'coordination'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Core',
  points: 14,
  instructions:
    'Bear Crawl makes you strong like a bear! Get on your hands and feet with your bottom up in the air, then crawl forward like a bear! Keep your bottom up high!',
  timedInstructions: [
    // SET 1: POLAR BEAR (Arctic Adventure)
    {
      time: 0,
      text: "Imagine you're a polar bear in the Arctic! Get on your hands and feet with your bottom up in the air, then crawl forward like a bear! Keep your bottom up high!",
    },
    {
      time: 4,
      text: 'Crawl forward, Arctic bear!',
    },
    {
      time: 6,
      text: 'The snow is thick, crawl forward!',
    },
    {
      time: 8,
      text: 'Keep crawling, you got this!',
    },
    {
      time: 10,
      text: 'No snow is going to stop you!',
    },
    {
      time: 12,
      text: "You're a polar bear, keep crawling!",
    },
    {
      time: 14,
      text: "Oops, there's something in the way... quick crawl backward now!",
    },
    {
      time: 16,
      text: "Let's crawl backward like the strong polar bear you are!",
    },
    {
      time: 18,
      text: 'Crawl forward, the ice is calling!',
    },
    {
      time: 20,
      text: 'Keep crawling, polar bear power!',
    },
    {
      time: 22,
      text: "Crawl forward, you're unstoppable!",
    },
    {
      time: 24,
      text: 'Keep crawling, Arctic champion!',
    },
    {
      time: 26,
      text: 'Crawl backward now, ice warrior!',
    },
    {
      time: 28,
      text: "You're a strong polar bear!", // Encouragement
    },
    {
      time: 30,
      text: 'Keep crawling, snow master!',
    },
    // REST PERIOD 1 - 15 seconds
    {
      time: 32,
      text: 'Amazing job! Take a good break now',
    },
    {
      time: 35,
      text: 'Breathe in and out, catch your breath',
    },
    {
      time: 38,
      text: "You just did 10 bear crawls, that's incredible!",
    },
    {
      time: 41,
      text: 'Your core and coordination are getting so strong!',
    },
    {
      time: 44,
      text: 'Remember to keep your bottom up high',
    },
    {
      time: 47,
      text: 'Keep your hands and feet moving together',
    },
    {
      time: 50,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 53,
      text: "You're building amazing bear strength!",
    },
    {
      time: 56,
      text: 'Ready for round two, bear warrior!',
    },
    {
      time: 59,
      text: '3, 2, 1, GO!',
    },
    // SET 2: GRIZZLY BEAR (Forest Adventure)
    {
      time: 62,
      text: "Now you're a grizzly bear in the forest!",
    },
    {
      time: 64,
      text: 'Crawl forward, forest grizzly!',
    },
    {
      time: 66,
      text: 'The trees are watching, crawl forward!',
    },
    {
      time: 68,
      text: "Keep crawling, you're fierce!",
    },
    {
      time: 70,
      text: 'No tree roots can stop you!',
    },
    {
      time: 72,
      text: "You're a grizzly bear, keep crawling!",
    },
    {
      time: 74,
      text: 'Crawl backward now, forest explorer!',
    },
    {
      time: 76,
      text: "Let's crawl backward like the mighty grizzly you are!",
    },
    {
      time: 78,
      text: 'Crawl forward, the forest is calling!',
    },
    {
      time: 80,
      text: 'Keep crawling, grizzly power!',
    },
    {
      time: 82,
      text: "Crawl forward, you're unstoppable!",
    },
    {
      time: 84,
      text: 'Keep crawling, forest champion!',
    },
    {
      time: 86,
      text: "You're getting stronger!", // Encouragement
    },
    {
      time: 88,
      text: 'Crawl forward, forest warrior!',
    },
    {
      time: 90,
      text: 'Keep crawling, tree master!',
    },
    // REST PERIOD 2 - 15 seconds
    {
      time: 92,
      text: 'Amazing job! Take another break',
    },
    {
      time: 95,
      text: 'Breathe in and out, feel your strength',
    },
    {
      time: 98,
      text: 'You just did 20 bear crawls total!',
    },
    {
      time: 101,
      text: 'Your core and coordination are getting stronger!',
    },
    {
      time: 104,
      text: 'Remember to keep your bottom up high',
    },
    {
      time: 107,
      text: 'Keep your hands and feet moving together',
    },
    {
      time: 110,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 113,
      text: "You're becoming a bear crawl master!",
    },
    {
      time: 116,
      text: 'Ready for round three, bear champion!',
    },
    {
      time: 119,
      text: '3, 2, 1, GO!',
    },
    // SET 3: PANDA BEAR (Bamboo Forest Adventure)
    {
      time: 122,
      text: "Now you're a panda bear in the bamboo forest!",
    },
    {
      time: 124,
      text: 'Crawl forward, bamboo panda!',
    },
    {
      time: 126,
      text: 'The bamboo is everywhere, crawl forward!',
    },
    {
      time: 128,
      text: "Keep crawling, you're adorable!",
    },
    {
      time: 130,
      text: 'No bamboo can stop you!',
    },
    {
      time: 132,
      text: "You're a panda bear, keep crawling!",
    },
    {
      time: 134,
      text: 'Crawl backward now, bamboo explorer!',
    },
    {
      time: 136,
      text: "Let's crawl backward like the cute panda you are!",
    },
    {
      time: 138,
      text: 'Crawl forward, the bamboo is calling!',
    },
    {
      time: 140,
      text: 'Keep crawling, panda power!',
    },
    {
      time: 142,
      text: "Crawl forward, you're unstoppable!",
    },
    {
      time: 144,
      text: 'Keep crawling, bamboo champion!',
    },
    {
      time: 146,
      text: 'Keep going, champion!', // Encouragement
    },
    {
      time: 148,
      text: 'Crawl forward, bamboo warrior!',
    },
    {
      time: 150,
      text: 'Keep crawling, bamboo master!',
    },
    // REST PERIOD 3 - 15 seconds
    {
      time: 152,
      text: 'Amazing job! Take a final break',
    },
    {
      time: 155,
      text: 'Breathe in and out, feel your strength',
    },
    {
      time: 158,
      text: 'You just did 30 bear crawls total!',
    },
    {
      time: 161,
      text: 'Your core and coordination are incredibly strong!',
    },
    {
      time: 164,
      text: 'Remember to keep your bottom up high',
    },
    {
      time: 167,
      text: 'Keep your hands and feet moving together',
    },
    {
      time: 170,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 173,
      text: "You're a bear crawl superstar!",
    },
    {
      time: 176,
      text: 'Ready for the final round, bear master!',
    },
    {
      time: 179,
      text: '3, 2, 1, GO!',
    },
    // SET 4: BROWN BEAR (Mountain Adventure)
    {
      time: 182,
      text: "Now you're a brown bear in the mountains!",
    },
    {
      time: 184,
      text: 'Crawl forward, mountain brown bear!',
    },
    {
      time: 186,
      text: 'The mountains are high, crawl forward!',
    },
    {
      time: 188,
      text: "Keep crawling, you're powerful!",
    },
    {
      time: 190,
      text: 'No mountain can stop you!',
    },
    {
      time: 192,
      text: "You're a brown bear, keep crawling!",
    },
    {
      time: 194,
      text: 'Crawl backward now, mountain explorer!',
    },
    {
      time: 196,
      text: "Let's crawl backward like the mighty brown bear you are!",
    },
    {
      time: 198,
      text: "You smell that honey? It's straight ahead!",
    },
    {
      time: 200,
      text: 'Crawl forward now, the honey is calling!',
    },
    {
      time: 202,
      text: "Crawl forward, you're unstoppable!",
    },
    {
      time: 204,
      text: 'Keep crawling, mountain champion!',
    },
    {
      time: 206,
      text: 'Bees are swarming! Crawl backward now, retreat!', // Encouragement
    },
    {
      time: 208,
      text: 'Keep crawling backward, the bees are coming!',
    },
    {
      time: 210,
      text: 'Phew, you got away! Mountain master!',
    },
    {
      time: 212,
      text: 'You did it, champion!', // Encouragement
    },
    {
      time: 214,
      text: 'Incredible work! You did 40 bear crawls!',
    },
    {
      time: 216,
      text: 'Your core and coordination are incredibly strong!',
    },
    {
      time: 218,
      text: 'You are a bear master!',
    },
  ],
};
